export default "__VITE_ASSET__DQ1b9psQ__"